import type { SVGProps } from 'react';

export function GenAILogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="4" fill="url(#logoGradient)" />
      <path
        d="M14.9684 21.8451C14.595 23.385 12.405 23.385 12.0316 21.8451L11.0042 17.6081C10.8709 17.0584 10.4416 16.6291 9.89187 16.4958L5.65488 15.4684C4.11504 15.095 4.11504 12.905 5.65488 12.5316L9.89187 11.5042C10.4416 11.3709 10.8709 10.9416 11.0042 10.3919L12.0316 6.15488C12.405 4.61504 14.595 4.61504 14.9684 6.15488L15.9958 10.3919C16.1291 10.9416 16.5584 11.3709 17.1081 11.5042L21.3451 12.5316C22.885 12.905 22.885 15.095 21.3451 15.4684L17.1081 16.4958C16.5584 16.6291 16.1291 17.0584 15.9958 17.6081L14.9684 21.8451Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 20.2067L14.2337 17.1809C14.527 15.9714 15.4714 15.027 16.6809 14.7337L19.7067 14L16.6809 13.2663C15.4714 12.973 14.527 12.0286 14.2337 10.8191L13.5 7.79328L12.7663 10.8191C12.473 12.0286 11.5286 12.973 10.3191 13.2663L7.29328 14L10.3191 14.7337C11.5286 15.027 12.473 15.9714 12.7663 17.1809L13.5 20.2067ZM12.0316 21.8451C12.405 23.385 14.595 23.385 14.9684 21.8451L15.9958 17.6081C16.1291 17.0584 16.5584 16.6291 17.1081 16.4958L21.3451 15.4684C22.885 15.095 22.885 12.905 21.3451 12.5316L17.1081 11.5042C16.5584 11.3709 16.1291 10.9416 15.9958 10.3919L14.9684 6.15488C14.595 4.61504 12.405 4.61504 12.0316 6.15488L11.0042 10.3919C10.8709 10.9416 10.4416 11.3709 9.89187 11.5042L5.65488 12.5316C4.11504 12.905 4.11504 15.095 5.65488 15.4684L9.89187 16.4958C10.4416 16.6291 10.8709 17.0584 11.0042 17.6081L12.0316 21.8451Z"
        fill="black"
      />
      <path
        d="M24.1526 26.4867C23.9867 27.1711 23.0133 27.1711 22.8474 26.4867L22.3908 24.6036C22.3315 24.3593 22.1407 24.1685 21.8964 24.1092L20.0133 23.6526C19.3289 23.4867 19.3289 22.5133 20.0133 22.3474L21.8964 21.8908C22.1407 21.8315 22.3315 21.6407 22.3908 21.3964L22.8474 19.5133C23.0133 18.8289 23.9867 18.8289 24.1526 19.5133L24.6092 21.3964C24.6685 21.6407 24.8593 21.8315 25.1036 21.8908L26.9867 22.3474C27.6711 22.5133 27.6711 23.4867 26.9867 23.6526L25.1036 24.1092C24.8593 24.1685 24.6685 24.3593 24.6092 24.6036L24.1526 26.4867Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 25.7585L23.8261 24.4137C23.9564 23.8762 24.3762 23.4565 24.9137 23.3261L26.2585 23L24.9137 22.6739C24.3762 22.5435 23.9564 22.1238 23.8261 21.5863L23.5 20.2415L23.1739 21.5863C23.0436 22.1238 22.6238 22.5435 22.0863 22.6739L20.7415 23L22.0863 23.3261C22.6238 23.4564 23.0436 23.8762 23.1739 24.4137L23.5 25.7585ZM22.8474 26.4867C23.0133 27.1711 23.9867 27.1711 24.1526 26.4867L24.6092 24.6036C24.6685 24.3593 24.8593 24.1685 25.1036 24.1092L26.9867 23.6526C27.6711 23.4867 27.6711 22.5133 26.9867 22.3474L25.1036 21.8908C24.8593 21.8315 24.6685 21.6407 24.6092 21.3964L24.1526 19.5133C23.9867 18.8289 23.0133 18.8289 22.8474 19.5133L22.3908 21.3964C22.3315 21.6407 22.1407 21.8315 21.8964 21.8908L20.0133 22.3474C19.3289 22.5133 19.3289 23.4867 20.0133 23.6526L21.8964 24.1092C22.1407 24.1685 22.3315 24.3593 22.3908 24.6036L22.8474 26.4867Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="logoGradient"
          x1="27.3137"
          y1="27.3137"
          x2="4.68629"
          y2="4.68629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F44097" />
          <stop offset="1" stopColor="#FC67FA" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GenAILogo;
